// Notification setting
export const TOAST = {
  SucessColor: "#359E0B",
  WarningColor: "#FFB442",
  ErrorColor: "#FF6970",
  InfoColor: "#157CCF",

  MessageColor: "#FFFFFF",
  MessageSize: "18",
  TimeOut: 7000,

  Position: "bottomRight",
}

//for smart contract
export const ACCOUNT_CONTRACT = "genereospool"
export const BP_TABLE = process.env.REACT_APP_BP_TABLE || "vf.bps"
export const PROXYS_TABLE = process.env.REACT_APP_PROXY_TABLE || "vf.proxies"
export const REFERRAL_TABLE = "vf.referrals"

export const CHAIN_NAME = process.env.REACT_APP_CHAIN_NAME || "Vaulta"
export const CORE_CONTRACT = process.env.REACT_APP_CORE_CONTRACT || "core.vaulta"
export const CORE_TOKEN_CONTRACT = process.env.REACT_APP_CORE_TOKEN_CONTRACT || CORE_CONTRACT
export const CORE_TOKEN_SYMBOL = process.env.REACT_APP_CORE_TOKEN_SYMBOL || "A"

//for country language
export const EN = "en"
export const CH = "ch"
export const KR = "kr"

export const ENTER = 13
export const ESC = 27
export const HOME = 36

export const PROXY_ACCOUNT = 1
export const BP_ACCOUNT = 2
export const NORMAL_ACCOUNT = 3

export const SUCCESS = 200

export const BACK_END_URL = process.env.REACT_APP_BACKEND_URL || "https://us-central1-genpool-ad9fa.cloudfunctions.net"
export const CHAIN_API_URL = process.env.REACT_APP_CHAIN_API_URL
